import { useJsApiLoader } from "@react-google-maps/api";
import { useEffect, useState } from "react"
import { env } from "../../env";
import { get } from "lodash";

export const useDistanceHook = ({ from = "Stanisława Sadowskiego 12, 85-151 Bydgoszcz", to = "" } = {}) => {
    const [data, setData] = useState(null);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: env.REACT_APP_GOOGLE_MAPS_API_KEY
    });

    const blankValue = { distance: { text: null, value: null }, duration: { text: null, value: null } }

    useEffect(() => {
        if (!isLoaded) return blankValue;

        const service = new window.google.maps.DistanceMatrixService();

        service.getDistanceMatrix(
            {
                origins: [from],
                destinations: [to],
                travelMode: window.google.maps.TravelMode.DRIVING,
                unitSystem: window.google.maps.UnitSystem.METRIC
            },
            (response, status) => {
                if (status === "OK") {
                    setData(get(response, 'rows[0].elements[0]', blankValue))
                }
            }
        );
    }, [isLoaded])

    if (!data)
        return blankValue;

    delete data.status
    return data;
}